import { ArtBoardNS } from "../../../../../../ArtBoard/ArtBoardNS.js";
import { BackgroundNS } from "../../../../../../Background/BackgroundNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
import { BaseNS } from "../../Base/BaseNS.js";
import { calculateViewBoxFitToArtBoard } from "../private/calculateViewBoxFitToArtBoard.js";
export class GridStickerMobileEditor {
  constructor({ window, document }) {
    BaseNS._constructor(this, {
      window,
      document,
    });
  }
  initDOM() {
    return BaseNS.initDOM(this);
  }
  initEditor() {
    return BaseNS.initEditor(this);
  }
  destroy() {
    return BaseNS.destroy(this);
  }
  appendTo(container_el) {
    return BaseNS.appendTo(this, container_el);
  }
  fitSize() {
    return BaseNS.fitSize(this);
  }
  setArtBoardSize(size) {
    return BaseNS.setArtBoardSize(this, size);
  }
  calculateViewBoxFitToArtBoard(config) {
    return calculateViewBoxFitToArtBoard(this, config);
  }
  setViewBox(view_box_vo) {
    return BaseNS.setViewBox(this, view_box_vo);
  }
  addGrid(grid) {
    return BaseNS.addGrid(this, grid);
  }
  selectGrid(id) {
    return BaseNS.selectGrid(this, id);
  }
  getTargetImage(id) {
    return BaseNS.getTargetImage(this, id);
  }
  setTargetImage(target_image_payload) {
    return BaseNS.setTargetImage(this, target_image_payload);
  }
  unsetTargetImage(id) {
    return BaseNS.unsetTargetImage(this, id);
  }
  getBackground() {
    return BaseNS.getBackground(this);
  }
  setBackground(background_value_vo) {
    return BaseNS.setBackground(this, background_value_vo);
  }
  setForeground(el) {
    return BaseNS.setForeground(this, el);
  }
  getIsAllGridExisting() {
    return BaseNS.getIsAllGridExisting(this);
  }
  startCopy() {
    return BaseNS.startCopy(this);
  }
  selectCopyDestination(id) {
    return BaseNS.selectCopyDestination(this, id);
  }
  unselectCopyDestination(id) {
    return BaseNS.unselectCopyDestination(this, id);
  }
  getOverrideCopyDestinationGridIds() {
    return BaseNS.getOverrideCopyDestinationGridIds(this);
  }
  endCopy(copyTargetImageEl) {
    return BaseNS.endCopy(this, copyTargetImageEl);
  }
  abortCopy() {
    return BaseNS.abortCopy(this);
  }
  exportEditor(payload) {
    return BaseNS.exportEditor(this, payload);
  }
  _getContainerElThrowable() {
    return BaseNS._getContainerElThrowable(this);
  }
  _getCanvasElThrowable() {
    return BaseNS._getCanvasElThrowable(this);
  }
  _getLayersElThrowable() {
    return BaseNS._getLayersElThrowable(this);
  }
  _getArtBoardLayerElThrowable() {
    return BaseNS._getArtBoardLayerElThrowable(this);
  }
  _getBackgroundLayerElThrowable() {
    return BaseNS._getBackgroundLayerElThrowable(this);
  }
  _getTargetImageLayerElThrowable() {
    return BaseNS._getTargetImageLayerElThrowable(this);
  }
  _getForegroundLayerElThrowable() {
    return BaseNS._getForegroundLayerElThrowable(this);
  }
  _getClipPathLayerElThrowable() {
    return BaseNS._getClipPathLayerElThrowable(this);
  }
  _getEmptyGridLayerElThrowable() {
    return BaseNS._getEmptyGridLayerElThrowable(this);
  }
  _getExistingGridLayerElThrowable() {
    return BaseNS._getExistingGridLayerElThrowable(this);
  }
  _getSelectorGridLayerElThrowable() {
    return BaseNS._getSelectorGridLayerElThrowable(this);
  }
  _getCopySourceGridLayerElThrowable() {
    return BaseNS._getCopySourceGridLayerElThrowable(this);
  }
  _getCopyDestinationUnselectedEmptyGridLayerElThrowable() {
    return BaseNS._getCopyDestinationUnselectedEmptyGridLayerElThrowable(this);
  }
  _getCopyDestinationUnselectedExistingGridLayerElThrowable() {
    return BaseNS._getCopyDestinationUnselectedExistingGridLayerElThrowable(
      this
    );
  }
  _getCopyDestinationSelectedGridLayerElThrowable() {
    return BaseNS._getCopyDestinationSelectedGridLayerElThrowable(this);
  }
  _getArtBoardRectElThrowable() {
    return BaseNS._getArtBoardRectElThrowable(this);
  }
  _getArtBoardFilterDropShadowElThrowable() {
    return BaseNS._getArtBoardFilterDropShadowElThrowable(this);
  }
  _getBackgroundBaseElThrowable() {
    return BaseNS._getBackgroundBaseElThrowable(this);
  }
  _getBackgroundColorElThrowable() {
    return BaseNS._getBackgroundColorElThrowable(this);
  }
  _getBackgroundImageElThrowable() {
    return BaseNS._getBackgroundImageElThrowable(this);
  }
  _getClipPathElThrowable() {
    return BaseNS._getClipPathElThrowable(this);
  }
  _getViewPortThrowable() {
    return BaseNS._getViewPortThrowable(this);
  }
  _getViewBoxThrowable() {
    return BaseNS._getViewBoxThrowable(this);
  }
  _getArtBoardThrowable() {
    return BaseNS._getArtBoardThrowable(this);
  }
  _getBackgroundThrowable() {
    return BaseNS._getBackgroundThrowable(this);
  }
}
